export const actions = {
  REQUEST: 'PRINTER_REQUEST',
};

export const printerRequest = ({ label }) => ({
  type: actions.REQUEST,
  payload: label,
});
